var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bb-card categories-card",
      attrs: { id: "categories_input" },
    },
    [
      _c(
        "div",
        { staticClass: "categories-container" },
        _vm._l(_vm.allCategories, function (category) {
          return _c(
            "div",
            {
              key: category.id,
              staticClass: "single-category-card",
              class: _vm.additionalCategoryClasses(category.id),
              on: {
                click: function ($event) {
                  return _vm.handleCategorySelect(category.id)
                },
              },
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCategoryDisabled(category.id),
                    expression: "isCategoryDisabled(category.id)",
                  },
                ],
                staticClass: "disabled-category-overlay",
              }),
              _vm.isCategorySelected(category.id)
                ? _c("div", { staticClass: "selected-category-badge" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-check",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "15",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [_c("polyline", { attrs: { points: "20 6 9 17 4 12" } })]
                    ),
                  ])
                : _vm._e(),
              _c("div", {
                staticClass: "category-image",
                style: {
                  "background-image": "url(" + category.image.url + ")",
                },
              }),
              _c("div", { staticClass: "category-name" }, [
                _c("span", [_vm._v(_vm._s(category.name))]),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }